import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { emptyObject } from 'ui-components/default-props/empty';

import { ShipFromLabel } from './address/ship-from-label';
import messages from './messages';
import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import { AddressPropType } from '../../../../../prop-types/address';
import ReadonlyField from '../../../fulfillment/fields/readonly-field';
import { ReadOnlyShipTo } from '../../../fulfillment-plan/sections/shipment-details/address/read-only-shipto';
import { ReturnDetailsLayoutLoader } from '../../../layouts/return-details-layout/return-details-layout-loader';

const Content = ({
  returnShipmentDetails = {
    shipTo: emptyObject,
    recipientInfo: emptyObject,
  },
}) => {
  const { rmaNumber, shipTo, recipientInfo, voidedDateTime, receivedDateTime, createdDateTime } = returnShipmentDetails;

  const addressColumnContent = (
    <ReadonlyField label={<ShipFromLabel />}>
      <ReadOnlyShipTo recipientInfo={recipientInfo} shipTo={shipTo} />
    </ReadonlyField>
  );

  const dateColumnContent = (
    <>
      <ReadonlyField label={<FormattedMessage {...messages.createdDateLabel} />}>
        {createdDateTime ? <UserDateTimezoneFormat dateTime={createdDateTime} /> : null}
      </ReadonlyField>
      <ReadonlyField label={<FormattedMessage {...messages.receivedDateLabel} />}>
        {receivedDateTime ? <UserDateTimezoneFormat dateTime={receivedDateTime} /> : null}
      </ReadonlyField>
      {voidedDateTime ? (
        <ReadonlyField label={<FormattedMessage {...messages.voidedDateLabel} />}>
          <UserDateTimezoneFormat dateTime={voidedDateTime} />
        </ReadonlyField>
      ) : null}
    </>
  );

  const rmaColumnContent = <ReadonlyField label={<FormattedMessage {...messages.rmaNumberLabel} />}>{rmaNumber}</ReadonlyField>;

  return (
    <ReturnDetailsLayoutLoader
      addressColumnContent={addressColumnContent}
      dateColumnContent={dateColumnContent}
      rmaColumnContent={rmaColumnContent}
    />
  );
};

export default Content;

Content.propTypes = {
  returnShipmentDetails: PropTypes.shape({
    rmaNumber: PropTypes.string,
    shipTo: AddressPropType.isRequired,
    voidedDateTime: PropTypes.string,
    receivedDateTime: PropTypes.string,
    createdDateTime: PropTypes.string,
    recipientInfo: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
    }),
  }),
};
